import { getLoadMstv } from './mstv-player-loader';

export function stickyVideo(dataEdtn, isAutoPlay) {
  let videoBoxWrapper = document.getElementsByClassName('videowrapper')[0]; //mstv-video-wrapper
  let videoBoxWrappersInArticle = document.querySelectorAll('.video-wrapper');
  let videoWrapper, isMstv, isYoutube;

  if (videoBoxWrapper) {
    videoWrapper = videoBoxWrapper.getElementsByClassName('video-player')[0]; //video-player

    isMstv = videoWrapper.dataset.videoName == 'mstv' ? true : false;
    isYoutube = videoWrapper.dataset.videoName == 'youtube' ? true : false;
  }

  if (videoBoxWrappersInArticle != null) {
    for (let videoBoxWrapperInArticle of videoBoxWrappersInArticle) {
      let videoWrapperInArticle =
        videoBoxWrapperInArticle.getElementsByClassName('video-player')[0]; //video-player

      if (videoWrapperInArticle instanceof Element) {
        isMstv =
          videoWrapperInArticle.dataset.videoName == 'mstv' ? true : false;
        isYoutube =
          videoWrapperInArticle.dataset.videoName == 'youtube' ? true : false;

        getLoadMstv().then((api) => {
          api.loadMstv(
            videoWrapperInArticle,
            dataEdtn,
            isMstv,
            isAutoPlay,
            isYoutube,
          );
        });
      }
    }
  }

  if (videoWrapper != null) {
    getLoadMstv().then((api) => {
      api.loadMstv(videoWrapper, dataEdtn, isMstv, isAutoPlay, isYoutube);
    });
  }
}
